export default "__VITE_ASSET__Clw65eLj__"